import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { authApi } from '@/lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await authApi.forgotPassword(email);

      if (response.data.success) {
        toast.success('Reset code sent! Check your email.');
        navigate(`/reset-password?email=${encodeURIComponent(email)}`);
      }
    } catch (error: unknown) {
      const err = error as { response?: { data?: { error?: { message?: string } } } };
      toast.error(err.response?.data?.error?.message || 'Failed to send reset code');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="animate-fade-in">
      <div className="lg:hidden mb-8 text-center">
        <Link to="/" className="font-display text-2xl font-bold text-charcoal tracking-tight">
          venndela
        </Link>
      </div>

      <h2 className="font-serif text-3xl text-charcoal mb-2">Forgot password?</h2>
      <p className="text-charcoal/60 mb-8">
        Enter your email and we'll send you a code to reset your password.
      </p>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="email" className="label">Email address</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input"
            placeholder="you@example.com"
            required
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="btn btn-primary w-full py-3"
        >
          {isLoading ? 'Sending...' : 'Send reset code'}
        </button>
      </form>

      <p className="mt-8 text-center text-sm text-charcoal/60">
        Remember your password?{' '}
        <Link to="/login" className="text-rust hover:text-rust-light font-medium">
          Sign in
        </Link>
      </p>
    </div>
  );
}
